import type { ReactNode } from 'react';
import './VisuallyHidden.css';

/**
 * Screen-reader-only text. Per docs/design-system/components.md Tier 1 and
 * a11y.md §5 (accessible names on icon-only controls, live-region text, etc.)
 *
 * ⚠️ **Backed by a real `.dpr-visually-hidden` class since 2026-08-08, and that is the point of
 * the change.** It applied inline styles and exposed no selector, so anything needing the same
 * treatment on an element it did not own — a `<caption>`, a `<span>` inside another component's
 * markup — had to re-implement it. `DataTable` referenced the class name anyway and rendered its
 * caption visibly in `apps/admin`; three other components copied the block into their own
 * stylesheets. One technique, four implementations, none of them able to fix the others.
 *
 * `className` composes rather than replaces, so a caller can still position the box.
 */
export function VisuallyHidden({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <span className={`dpr-visually-hidden${className ? ` ${className}` : ''}`}>{children}</span>
  );
}
